export default function validate(values) {
    const errors = {};
    let hasErrors = false;

    if (!values.old_password || values.old_password.trim() === '') {
        errors.old_password = 'Old password is required';
        hasErrors = true;
    }

    if (!values.new_password || values.new_password.trim() === '') {
        errors.new_password = 'New password is required';
        hasErrors = true;
    }

    if (!values.new_password_confirmation || values.new_password_confirmation.trim() === '') {
        errors.new_password_confirmation = 'New password confirmation is required.';
        hasErrors = true;
    } else if (values.new_password !== values.new_password_confirmation) {
        errors.email = 'New password doesn\'t match';
        hasErrors = true;
    }

    return hasErrors && errors;
}
